import React, { useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import "./styles/form.css";
import * as Yup from "yup";
import { loadProgressBar } from "x-axios-progress-bar";
import "x-axios-progress-bar/dist/nprogress.css";
import { onClickPopulateLists } from "./utilities";

//const port = process.env.REACT_APP_PORT2;
const baseUrl = process.env.REACT_APP_HOST;

const ObserverForm = () => {
  const [currentLists, setCurrentLists] = useState([]);
  loadProgressBar();
  const formik = useFormik({
    initialValues: {
      ObserverID: "",
      LastName: "",
      FirstName: "",
      LastName: "",
      Collection: "",
      List: "",
      Notes: "",
    },
    validationSchema: Yup.object({
      ObserverID: Yup.string()
        .max(100, "Please enter a last name.")
        .required("ObserverID is Required"),
      LastName: Yup.string()
        .max(100, "Please enter last name")
        .required("Last Name is Required"),
      FirstName: Yup.string()
        .max(100, "Please enter a first name.")
        .required("First Name is Required"),
      LastName: Yup.string()
        .max(100, "Please enter last name")
        .required("Last Name is Required"),
      Collection: Yup.string()
        .max(100, "Please enter a collection.")
        .required("Collection is Required"),
      List: Yup.string()
        .max(100, "Please enter a list number.")
        .required("List is Required"),
    }),
    onSubmit: (values) => {
      axios
        .get(baseUrl + "findName", {
          params: { ObserverID: formik.values.ObserverID },
        })
        .then((response) => {
          if (response.data == "Name not in database") {
            axios
              .get(baseUrl + "sendObserverEntry", {
                params: {
                  ObserverID: formik.values.ObserverID,
                  LastName: formik.values.LastName,
                  FirstName: formik.values.FirstName,
                  LastName: formik.values.LastName,
                  Collection: formik.values.Collection,
                  List: formik.values.List,
                  Notes: formik.values.Notes,
                },
              })
              .then((res) => {
                if (res.data === "23505") {
                } else {
                  alert("New observer entry created.\n\n");
                }
              })
              .catch((err) => {
                alert(err.message);
              });
          } else {
            if (window.confirm("Do you want to update this record?")) {
              axios
                .get(baseUrl + "updateObserver", {
                  params: {
                    ObserverID: formik.values.ObserverID,
                    LastName: formik.values.LastName,
                    FirstName: formik.values.FirstName,
                    LastName: formik.values.LastName,
                    Collection: formik.values.Collection,
                    List: formik.values.List,
                    Notes: formik.values.Notes,
                  },
                })
                .then((result) => {
                  console.log(result.data);
                  alert("Observer entry updated.\n\n");
                });
            } else {
              alert("Did not update observer.");
            }
          }
        });
    },
  });
  return (
    <div class="AddObserverForm">
      <form id="observerForm" onSubmit={formik.handleSubmit}>
        <legend>Observer Entry Form</legend>
        <table class="BasicInfoTable">
          <tr>
            <td>
              <label class="BasicInfoLabel">ObserverID</label>
            </td>
            <td>
              <input
                class="BasicInput"
                type="text"
                name="ObserverID"
                id="ObserverID"
                onChange={formik.handleChange}
                value={formik.values.ObserverID}
                list="namesList"
                onFocus={() => {
                  axios.get(baseUrl + "getAllNames").then((res) => {
                    var nameslist = document.getElementById("namesList");
                    while (nameslist.hasChildNodes()) {
                      nameslist.removeChild(nameslist.firstChild);
                    }
                    var name;
                    var option;
                    for (name in res.data) {
                      option = document.createElement("option");
                      option.value = res.data[name].ObserverID;
                      option.label = res.data[name].ObserverID;
                      document.getElementById("namesList").appendChild(option);
                    }
                  });
                }}
              ></input>
              <datalist id="namesList"></datalist>
            </td>
          </tr>
          {formik.touched.ObserverID && formik.errors.ObserverID ? (
            <div class="Error">{formik.errors.ObserverID}</div>
          ) : null}

          <tr>
            <td></td>
            <td>
              <div class="infoButton">
                <button
                  type="button"
                  class="btn btn-success"
                  onClick={() => {
                    if (!(formik.values.ObserverID == "")) {
                      console.log("formik.values.ObserverID: ");
                      onClickPopulateLists(
                        baseUrl,
                        formik.values.ObserverID
                      ).then((res) => {
                        console.log(
                          "onClickPopulateLists res.data: ",
                          res.data
                        );
                        setCurrentLists(res.data);
                      });
                      axios
                        .get(baseUrl + "getObserverInfo", {
                          params: { observer: formik.values.ObserverID },
                        })
                        .then((res) => {
                          if (!res.data.length == 0) {
                            var firstName = res.data[0].FirstName;
                            var lastName = res.data[0].LastName;
                            var collection = ""; //res.data[0].Collection;
                            var list = ""; //res.data[0].List;
                            var notes = res.data[0].Notes;

                            formik.values.FirstName = firstName;
                            formik.values.LastName = lastName;
                            formik.values.Collection = collection;
                            formik.values.List = list;
                            formik.values.Notes = notes;
                            document.getElementById("FirstName").value =
                              firstName;
                            document.getElementById("LastName").value =
                              lastName;
                            document.getElementById("Collection").value =
                              collection;
                            document.getElementById("List").value = list;
                            document.getElementById("Notes").value = notes;
                          }
                        });
                    }
                  }}
                >
                  Get Info.
                </button>
              </div>
              <div class="deleteButton">
                <button
                  type="button"
                  class="btn btn-success"
                  onClick={() => {
                    if (
                      window.confirm(
                        "Are you sure you want to delete this record?"
                      )
                    ) {
                      axios
                        .get(baseUrl + "deleteObserver", {
                          params: { observer: formik.values.ObserverID },
                        })
                        .then((res) => {
                          alert(res.data);
                          document.location();
                        });
                    } else {
                      alert("Record not deleted.");
                    }
                  }}
                >
                  Delete Observer
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label class="BasicInfoLabel">First Name</label>
            </td>
            <td>
              <input
                class="BasicInput"
                type="text"
                name="FirstName"
                id="FirstName"
                onChange={formik.handleChange}
                value={formik.values.FirstName}
              ></input>
            </td>
          </tr>
          {formik.touched.FirstName && formik.errors.FirstName ? (
            <div class="Error">{formik.errors.FirstName}</div>
          ) : null}

          <tr>
            <td>
              <label class="BasicInfoLabel">Last Name</label>
            </td>
            <td>
              <input
                class="BasicInput"
                type="text"
                name="LastName"
                id="LastName"
                onChange={formik.handleChange}
                value={formik.values.LastName}
              ></input>
            </td>
          </tr>
          {formik.touched.LastName && formik.errors.LastName ? (
            <div class="Error">{formik.errors.LastName}</div>
          ) : null}

          <tr>
            <td>
              <label class="BasicInfoLabel">Collection</label>
            </td>
            <td>
              <input
                class="BasicInput"
                type="text"
                name="Collection"
                id="Collection"
                onChange={formik.handleChange}
                value={formik.values.Collection}
                list="collectionsList"
                onFocus={() => {
                  axios.get(baseUrl + "getCollectionsList").then((res) => {
                    let collectionslist =
                      document.getElementById("collectionsList");
                    while (collectionslist.hasChildNodes()) {
                      collectionslist.removeChild(collectionslist.firstChild);
                    }
                    let collection;
                    let option;
                    for (collection in res.data) {
                      option = document.createElement("option");
                      option.value = res.data[collection].Collection;
                      option.label = res.data[collection].Collection;
                      document
                        .getElementById("collectionsList")
                        .appendChild(option);
                    }
                  });
                }}
              ></input>
              <datalist id="collectionsList"></datalist>
            </td>
          </tr>
          {formik.touched.Collection && formik.errors.Collection ? (
            <div class="Error">{formik.errors.Collection}</div>
          ) : null}

          <tr>
            <td>
              <label class="BasicInfoLabel">List</label>
            </td>
            <td>
              <input
                class="BasicInput"
                type="text"
                name="List"
                id="List"
                onChange={formik.handleChange}
                value={formik.values.List}
                list="listList"
                onFocus={() => {
                  axios.get(baseUrl + "getListList").then((res) => {
                    let listlist = document.getElementById("listList");
                    while (listlist.hasChildNodes()) {
                      listlist.removeChild(listlist.firstChild);
                    }
                    let list;
                    let option;
                    for (list in res.data) {
                      option = document.createElement("option");
                      option.value = res.data[list].List;
                      option.label = res.data[list].List;
                      document.getElementById("listList").appendChild(option);
                    }
                  });
                }}
              ></input>
              <datalist id="listList"></datalist>
            </td>
          </tr>
          {formik.touched.List && formik.errors.List ? (
            <div class="Error">{formik.errors.List}</div>
          ) : null}

          <tr>
            <td>
              <label class="BasicInfoLabel">Notes</label>
            </td>
            <td>
              <input
                class="BasicInput"
                type="text"
                name="Notes"
                id="Notes"
                onChange={formik.handleChange}
                value={formik.values.Notes}
              ></input>
            </td>
          </tr>
          {formik.touched.Notes && formik.errors.Notes ? (
            <div class="Error">{formik.errors.Notes}</div>
          ) : null}
        </table>
        {currentLists.length != 0 && (
          <table>
            <tr>
              <td>
                <label class="BasicInfoLabel">Current List(s)</label>
              </td>
              <td>
                <ul>
                  {currentLists.map((x) => {
                    return (
                      <li>
                        <span> List: {x.List} </span>
                        <span> Collection: {x.Collection} </span>
                      </li>
                    );
                  })}
                </ul>
              </td>
            </tr>
          </table>
        )}
        <button class="btn btn-success mb-4" type="submit">
          Create/Update
        </button>
      </form>
    </div>
  );
};

export default ObserverForm;

// CollectionsTest,